import React, { } from 'react';
import PropTypes from 'prop-types';
import CaseItemLink from './CaseItemLink';
import List from '@material-ui/core/List';
import { withStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import Grid from '@material-ui/core/Grid';
import { withRouter } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { connect } from 'react-redux';

const styles = theme => ({
    root: {

    },
  });

class CaseItemLinkList extends React.Component {

    state = {
        claimantFilter: ''
    }

    render() {
        const { classes, caseItems, context, history, match } = this.props;
        const { claimantFilter } = this.state;

        console.log('CaseItemLinkList caseItems: ', caseItems);
        if (caseItems == undefined) {
            return (
                <div className={classes.divStyle}>

                </div>
            );
        }
        else if (caseItems.length == 0) {
            if (localStorage.getItem('typeOfAccount') == 'arbitrator') {
                return (
                    <div className={classes.divStyle}>
                        <h4 className={classes.paper}> {context.t('There is no case in this account.')} </h4>
                    </div>
                );
            }
            else if (localStorage.getItem('typeOfAccount') == 'admin') {
                return (
                    <div className={classes.divStyle}>
                        <h4 className={classes.paper}> {context.t('There is no case in this account.')} </h4>
                    </div>
                );
            }
            else {
                return (
                    <div className={classes.divStyle}>
                        <h4 className={classes.paper}> {context.t('There is no case in this account.')} </h4>
                    </div>
                );
            }
        }
        else {

            const skipToken = localStorage.getItem('skipToken');
            const uniqueId = localStorage.getItem('uniqueId') || localStorage.getItem('skipUniqueId');
            const hasSkipCredentials = !!skipToken && !!uniqueId;

            if (caseItems.length == 1 && !hasSkipCredentials) {
                history.push(`${match.path}/${caseItems[0].caseId}`);
            }

            const filteredItems = claimantFilter === ''
                ? caseItems
                : caseItems.filter(item =>
                    item.claimantName && item.claimantName === claimantFilter
                  );

            // Build claimant names with case counts, sorted by count descending
            const claimantCountMap = {};
            caseItems.forEach(item => {
                if (item.claimantName && item.claimantName.trim() !== '') {
                    claimantCountMap[item.claimantName] = (claimantCountMap[item.claimantName] || 0) + 1;
                }
            });
            const claimantNames = Object.keys(claimantCountMap).sort((a, b) => claimantCountMap[b] - claimantCountMap[a]);

            return (
                <div className={classes.root}>
                    <div style={{padding: '16px 16px 8px 16px'}}>
                        <TextField
                            select
                            label="View by Claimant"
                            variant="outlined"
                            size="small"
                            value={claimantFilter}
                            onChange={(e) => this.setState({ claimantFilter: e.target.value })}
                            style={{width: '300px'}}
                        >
                            <MenuItem value="">
                                All ({caseItems.length})
                            </MenuItem>
                            {claimantNames.map((name) => (
                                <MenuItem key={name} value={name}>
                                    {name} ({claimantCountMap[name]})
                                </MenuItem>
                            ))}
                        </TextField>
                    </div>
                    <Grid container direction="row" alignItems="center" >
                        {
                            filteredItems.sort((a, b) => b.caseId - a.caseId).map((title, index) => (
                                <React.Fragment key={index}>
                                    <CaseItemLink primary={title} />
                                </React.Fragment>
                            ))
                        }
                    </Grid>
                </div>
            );
        }
    }
}

CaseItemLinkList.contextTypes = {
  t: PropTypes.func
}
export default withStyles(styles)(withRouter(CaseItemLinkList));